/**
 * Badge compacto que muestra el progreso de check-in de consentimiento.
 *  - completado    → verde "Check-in OK"
 *  - en progreso   → ámbar "X/6"
 *  - sin iniciar   → gris "Pendiente"
 */
import { CheckCircle2, Clock, Circle } from "lucide-react";
import Badge from "@/components/ui/Badge";
import type { ConsentProgress } from "@/hooks/useEventConsents";

interface Props {
  progress: ConsentProgress;
  className?: string;
}

export function ConsentStatusBadge({ progress, className = "" }: Props) {
  const { completed, doneCount, totalCount } = progress;

  if (completed) {
    return (
      <Badge
        className={`bg-green-100 text-green-700 hover:bg-green-100 gap-1 ${className}`}
      >
        <CheckCircle2 className="w-3 h-3" />
        Check-in OK
      </Badge>
    );
  }

  if (doneCount === 0) {
    return (
      <Badge
        className={`bg-gray-100 text-gray-600 hover:bg-gray-100 gap-1 ${className}`}
      >
        <Circle className="w-3 h-3" />
        Pendiente
      </Badge>
    );
  }

  return (
    <Badge
      className={`bg-amber-100 text-amber-700 hover:bg-amber-100 gap-1 ${className}`}
    >
      <Clock className="w-3 h-3" />
      {doneCount}/{totalCount}
    </Badge>
  );
}

export default ConsentStatusBadge;
